
// src/components/services/ServicesAccordion.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Pour les boutons CTA
import './ServicesAccordion.css';

function ServicesAccordionItem({ category, isOpen, onToggle }) {
  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <div 
        className="accordion-header" 
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={`content-${category.id}`}
        onKeyPress={(e) => e.key === 'Enter' && onToggle()}
      >
        <h3>{category.categoryTitle}</h3>
        <span className="accordion-toggle-icon">+</span>
      </div>
      {isOpen && (
        <div className="accordion-content" id={`content-${category.id}`}>
          <div className="accordion-plans-grid">
            {category.plans.map(plan => (
              <div key={plan.id} className="accordion-plan-card">
                <h4>{plan.title}</h4>
                {plan.subtitle && <p className="plan-subtitle">{plan.subtitle}</p>}
                <p className="plan-price">
                  <span className="plan-price-main">{plan.price}</span>
                  {plan.price_tax_label ? <span className="plan-price-tax"> {plan.price_tax_label}</span> : null}
                </p>
                {plan.priceSuffix && <p className="plan-price-suffix">{plan.priceSuffix}</p>}
                <ul className="plan-features">
                  {plan.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <Link 
                  to={`/contact?service=${encodeURIComponent(category.categoryTitle + " - " + plan.title)}`} 
                  className="btn btn-secondary plan-cta-button" // ou btn-primary
                >
                  Demander un devis
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function ServicesAccordion({ servicesData }) {
  const [openItemId, setOpenItemId] = useState(null); // ID de l'item ouvert

  const handleToggle = (itemId) => {
    setOpenItemId(openItemId === itemId ? null : itemId);
  };

  if (!servicesData || servicesData.length === 0) {
    return <p>Aucun service à afficher pour le moment.</p>;
  }

  return (
    <section className="services-accordion-section">
      <h2 className="section-title">Explorez nos Offres Détaillées</h2>
      <div className="accordion-container">
        {servicesData.map(category => (
          <ServicesAccordionItem 
            key={category.id}
            category={category}
            isOpen={openItemId === category.id}
            onToggle={() => handleToggle(category.id)}
          />
        ))}
      </div>
    </section>
  );
}

export default ServicesAccordion;